import { SwapButton, SwapCardContainer, SwapInput, SwapInputsContainer, SwapOutput, } from "@components";
import { useSwap, } from "@store";



/**
 * A component that provides the interface for buying brktETH tokens.
 * Allows users to input LRT/LST tokens and displays the amount of brktETH they will receive.
 * Handles token approval and swap functionality.
 *
 * @component
 * @returns {JSX.Element} A card component with swap inputs and action button for buying brktETH
 */
export const RedeemCard = () => {

	const {
		tokenIn,
		amountIn,
		amountOut,
		inputApproved,
		inputHasBalance,
		transacting,
		outputMaximum,
		quoting,
		native,
		approveBrktBuy,
		redeem,
	} = useSwap();

	return (
		<SwapCardContainer>
			<SwapInputsContainer>
				<SwapInput inputName={"Redeem BrktETH"} showUSD={false} />
				<SwapOutput inputName={"You receive LRT / LST"} disabled />
			</SwapInputsContainer>
			<SwapButton
				handleClick={inputApproved ? redeem : approveBrktBuy}
				isDisabled={Number(amountIn) <= 0}
				busy={transacting || quoting}
				busyText={native ? "obtaining swap, please wait" : undefined}
				label={
					!inputHasBalance ? "Exceeds your balance" :
					Number(amountOut) > ( Number(outputMaximum) / 1e18 ) ? "Exceeds maximum redeemable amount" :
					inputApproved && tokenIn.symbol !== "ETH" ? "Confirm and redeem" : 
					Number(amountIn) <= 0 || inputHasBalance ? `Approve ${tokenIn.symbol}` :
					"Exceeds your balance"
				}
			/>
		</SwapCardContainer>
	);

};

